import { Calendar } from './features/calendar/Calendar';
import { useTimeBlockState } from './features/calendar/hooks/useTimeBlockState';

function App() {
  const timeBlocks = useTimeBlockState();

  return (
    <div className="h-screen w-screen">
      <Calendar
        timeBlocks={timeBlocks.state.timeBlocks}
        onTimeBlockCreate={timeBlocks.actions.create}
        onTimeBlockUpdate={timeBlocks.actions.update}
        onTimeBlockDelete={timeBlocks.actions.delete}
      />
    </div>
  );
}

export default App;
